export var TRANSFORM_TYPE_FIT = 'fit';
export var TRANSFORM_TYPE_FILL = 'fill';
//# sourceMappingURL=constants.js.map